// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import * as ChimeSDK from 'amazon-chime-sdk-js';
import { DefaultMeetingReadinessChecker } from 'amazon-chime-sdk-js';

window.Chime = ChimeSDK;
window.DefaultMeetingReadinessChecker = DefaultMeetingReadinessChecker;

export * as default from 'amazon-chime-sdk-js';